import { render, staticRenderFns } from "./SidebarSettings.vue?vue&type=template&id=5e31fae7&"
import script from "./SidebarSettings.vue?vue&type=script&lang=js&"
export * from "./SidebarSettings.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports